import { Component, OnInit } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { ActivatedRoute, Router } from '@angular/router';
import { SelectItem } from 'primeng';
import { address, blockSpecialCharachters, city, dose_input, GOOGLE_RECAPTCHA_SITE_KEY, USER_TYPES, name_input, number_input, phoneNumber, textareaBox, zipCode } from 'src/app/constant/constant';
import { ErrorModel, PromiseResult, ServerError } from 'src/app/models/PromiseResult';
import { ResetPassword, User_Registration } from 'src/app/models/User';
import { UserService } from 'src/app/services/user.service';
import { UtilitiesService } from 'src/app/utilities/utilities.service';
import { TraceClassDecorator } from '@sentry/angular';
import { ProviderStateService } from 'src/app/services/provider-state.service';
@Component({
  selector: 'app-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.css', './../login-home/login-home.component.css']
})
@TraceClassDecorator()
export class ResetPasswordComponent implements OnInit {

  readonly name_input: RegExp = name_input;
  readonly address: RegExp = address;
  readonly city_input: RegExp = city;
  readonly phoneNumber: RegExp = phoneNumber;
  readonly zipCode: RegExp = zipCode;
  readonly textarea: RegExp = textareaBox;
  readonly dose_input: RegExp = dose_input;
  readonly number_input: RegExp = number_input;
  readonly blockSpecialCharachters: RegExp = blockSpecialCharachters;
  readonly sitekey: string = GOOGLE_RECAPTCHA_SITE_KEY;
  logo_url: string = '';
  slug: string = "";
  formPosting: boolean = false;
  isPassword: boolean = true;
  recaptcha_Reset: boolean = false;
  resetPasswordDone: boolean = false;
  recaptcha: any;
  user_data: User_Registration = new User_Registration();

  result: PromiseResult;
  countries: SelectItem[] = [];

  response: PromiseResult;
  error: ErrorModel;
  serverError: ServerError;

  ResetPass: ResetPassword = this.setResetPassword();
  tipsPasswordShowed: boolean = false;
  resetToken: null;

  constructor(
    private readonly userservice: UserService,
    private readonly router: Router,
    private readonly route: ActivatedRoute,
    private utilitiesService: UtilitiesService,
    private providerStateService: ProviderStateService

  ) {
    this.ResetPass = this.setResetPassword();
  }

  async ngOnInit(): Promise<void> {
    this.slug = this.providerStateService.getProviderSlug();
    this.user_data = new User_Registration();
    this.route.params.subscribe(params => {

      this.ResetPass.token = params.token;
      // this.ResetPass.egd_token = params.egd_token;
      //do key check

      try {
        if (params.hasOwnProperty('egd_token')) {
          this.ResetPass.egd_token = params.egd_token;
        }
        else {
          this.ResetPass.egd_token = "";
        }
        const len = this.ResetPass.egd_token.length;
      } catch (error) {
        this.ResetPass.egd_token = "";
      };
    });

    await this.reset_variables();
    await this.ResetError();
    await this.recaptchaReset();
    await this.ResetResultModels();
    this.logo_url = this.providerStateService.getLogoUrl();
  }

  changeType() {
    this.isPassword = !this.isPassword;
  }

  showTips() {
    this.tipsPasswordShowed = !this.tipsPasswordShowed;
  }

  private async ResetResultModels(): Promise<void> {
    this.response = {
      success: null,
      error: null,
      data: null
    };
    this.serverError = {
      statusCode: null,
      error: null,
      message: null
    }
  }

  async recaptchaReset() {
    this.recaptcha_Reset = false;
    setTimeout(() => {
      this.recaptcha_Reset = true;
    }, 1000)
  }

  resolved(captchaResponse: any) {
    this.recaptcha = captchaResponse;
    this.user_data.recaptcha = this.recaptcha;
    this.ResetPass.recaptcha = this.recaptcha;
  }

  setResetPassword(): ResetPassword {
    let ResetPass: ResetPassword;
    ResetPass = {
      e_password: null,
      token: null,
      egd_token: null,
      recaptcha: null,
    };
    return ResetPass;
  }

  ResetError() {
    this.result = { success: true, error: null, data: null }
  }

  reset_variables(): void {
    this.resetPasswordDone = false;
    this.ResetError();
    this.isPassword = true;
    this.result = { success: true, error: null, data: null }
    sessionStorage.clear();
  }

  async passwordResetSubmit() {
    this.formPosting = true;
    await this.recaptchaReset();
    //    await grecaptcha.reset();
    await this.resetPassword();
  }

  resetPassword(): void {
    this.ResetPass.e_password = this.user_data.e_password;
    this.ResetPass.recaptcha = this.recaptcha;
    this.recaptchaReset();
    this.userservice.resetPassword(this.ResetPass).toPromise()
      .then(result => {
        this.result = result;
        this.response = result;
        this.formPosting = false;

        if (this.result.success == true) {
          this.resetPasswordDone = true;
          setTimeout(() => {
            this.router.navigate(['/' + this.slug + '/']);

          }, 3000);
        }
      }).catch((error: HttpErrorResponse) => {
        this.serverError = error.error;
        this.response.success = false;
        this.formPosting = false;
      });
  }

  async openLink(base_url_name: string, link: string, target: string): Promise<void> {
    await this.utilitiesService.openWebsiteLinks(base_url_name, link, target);
  }

}
